import React from 'react';
import { Card } from '../components/UI/Card';
export const NetworkingGuide = () => {
  const steps = [{
    number: '1️⃣',
    title: 'Set Your Compass – What Do You Want?',
    content: <div className="space-y-4" data-id="element-2172">
          <p data-id="element-2173">Instead of "I must network more," ask:</p>
          <ul className="space-y-2" data-id="element-2174">
            <li className="flex items-start" data-id="element-2175">
              <span className="mr-2" data-id="element-2176">🔍</span>
              <span data-id="element-2177">What excites me about connecting with others?</span>
            </li>
            <li className="flex items-start" data-id="element-2178">
              <span className="mr-2" data-id="element-2179">🎯</span>
              <span data-id="element-2180">
                Am I seeking mentorship, collaboration, opportunities, or just
                inspiration?
              </span>
            </li>
            <li className="flex items-start" data-id="element-2181">
              <span className="mr-2" data-id="element-2182">💎</span>
              <span data-id="element-2183">What unique value do I bring into a conversation?</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-2184">
            <span className="mr-2" data-id="element-2185">✍️</span>
            <span data-id="element-2186">
              Exercise: Write 3 things you hope to gain from networking — and 3
              things you can give.
            </span>
          </p>
        </div>
  }, {
    number: '2️⃣',
    title: 'Design Your Introduction (Your Story in 30 Seconds)',
    content: <div className="space-y-4" data-id="element-2187">
          <p data-id="element-2188">
            Networking starts with clarity. But clarity doesn't mean rigidity.
          </p>
          <ul className="space-y-2" data-id="element-2189">
            <li className="flex items-start" data-id="element-2190">
              <span className="mr-2" data-id="element-2191">👤</span>
              <span data-id="element-2192">Who am I? (roles, passions, projects)</span>
            </li>
            <li className="flex items-start" data-id="element-2193">
              <span className="mr-2" data-id="element-2194">🌱</span>
              <span data-id="element-2195">What drives me? (purpose, values, interests)</span>
            </li>
            <li className="flex items-start" data-id="element-2196">
              <span className="mr-2" data-id="element-2197">🔗</span>
              <span data-id="element-2198">Who do I want to connect with right now?</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-2199">
            <span className="mr-2" data-id="element-2200">🎤</span>
            <span data-id="element-2201">
              Activity: Draft 2-3 "micro-intros" you can switch between (for
              events, LinkedIn, casual chats).
            </span>
          </p>
        </div>
  }, {
    number: '3️⃣',
    title: 'Choose Your Arena – Where Will You Play?',
    content: <div className="space-y-4" data-id="element-2202">
          <p data-id="element-2203">Networking happens everywhere:</p>
          <ul className="space-y-2" data-id="element-2204">
            <li className="flex items-start" data-id="element-2205">
              <span className="mr-2" data-id="element-2206">🎙</span>
              <span data-id="element-2207">Events & salons</span>
            </li>
            <li className="flex items-start" data-id="element-2208">
              <span className="mr-2" data-id="element-2209">📩</span>
              <span data-id="element-2210">DMs & email outreach</span>
            </li>
            <li className="flex items-start" data-id="element-2211">
              <span className="mr-2" data-id="element-2212">🌍</span>
              <span data-id="element-2213">Online communities & forums</span>
            </li>
            <li className="flex items-start" data-id="element-2214">
              <span className="mr-2" data-id="element-2215">☕</span>
              <span data-id="element-2216">Coffee chats</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-2217">
            <span className="mr-2" data-id="element-2218">🧭</span>
            <span data-id="element-2219">
              Prompt: Where do you already feel most comfortable starting? Where
              do you want to stretch yourself?
            </span>
          </p>
        </div>
  }, {
    number: '4️⃣',
    title: 'Practice the First Move',
    content: <div className="space-y-4" data-id="element-2220">
          <p data-id="element-2221">Instead of waiting for serendipity, design it.</p>
          <ul className="space-y-2" data-id="element-2222">
            <li data-id="element-2223">
              <strong data-id="element-2224">Warm path:</strong> Ask someone you know for an intro.
            </li>
            <li data-id="element-2225">
              <strong data-id="element-2226">Curious path:</strong> Reach out with a thoughtful
              question.
            </li>
            <li data-id="element-2227">
              <strong data-id="element-2228">Bold path:</strong> DM someone you admire with a specific
              compliment or idea.
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-2229">
            <span className="mr-2" data-id="element-2230">💡</span>
            <span data-id="element-2231">
              Challenge: This week, make 2 connections: one warm intro, one bold
              outreach.
            </span>
          </p>
        </div>
  }, {
    number: '5️⃣',
    title: 'Build Trust, Not Just Contacts',
    content: <div className="space-y-4" data-id="element-2232">
          <p data-id="element-2233">Think about conversations as bridges, not transactions.</p>
          <ul className="space-y-2" data-id="element-2234">
            <li className="flex items-start" data-id="element-2235">
              <span className="mr-2" data-id="element-2236">👂</span>
              <span data-id="element-2237">Listen deeply.</span>
            </li>
            <li className="flex items-start" data-id="element-2238">
              <span className="mr-2" data-id="element-2239">🎁</span>
              <span data-id="element-2240">
                Offer something of value (resource, insight, connection).
              </span>
            </li>
            <li className="flex items-start" data-id="element-2241">
              <span className="mr-2" data-id="element-2242">🔄</span>
              <span data-id="element-2243">
                Follow up quickly with gratitude + a simple next step.
              </span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-2244">
            <span className="mr-2" data-id="element-2245">✨</span>
            <span data-id="element-2246">
              Reflection: Recall the last time someone made you feel heard. How
              can you replicate that in your networking?
            </span>
          </p>
        </div>
  }, {
    number: '6️⃣',
    title: 'Keep the Web Alive',
    content: <div className="space-y-4" data-id="element-2247">
          <p data-id="element-2248">A network is like a garden — it needs tending.</p>
          <ul className="space-y-2" data-id="element-2249">
            <li className="flex items-start" data-id="element-2250">
              <span className="mr-2" data-id="element-2251">🌱</span>
              <span data-id="element-2252">Share updates about your journey.</span>
            </li>
            <li className="flex items-start" data-id="element-2253">
              <span className="mr-2" data-id="element-2254">🎉</span>
              <span data-id="element-2255">Celebrate others' wins.</span>
            </li>
            <li className="flex items-start" data-id="element-2256">
              <span className="mr-2" data-id="element-2257">🔗</span>
              <span data-id="element-2258">Connect people to each other.</span>
            </li>
            <li className="flex items-start" data-id="element-2259">
              <span className="mr-2" data-id="element-2260">📒</span>
              <span data-id="element-2261">
                Track relationships (Notion, Airtable, CRM, even your Notes
                app).
              </span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-2262">
            <span className="mr-2" data-id="element-2263">🛠</span>
            <span data-id="element-2264">
              Action: Create your personal "Connection Tracker" — 5 people to
              re-engage with this month.
            </span>
          </p>
        </div>
  }, {
    number: '7️⃣',
    title: 'Your Rules, Your Rhythm',
    content: <div className="space-y-4" data-id="element-2265">
          <p data-id="element-2266">
            Forget the idea that networking = constant hustle. It's about
            finding your rhythm:
          </p>
          <ul className="space-y-2" data-id="element-2267">
            <li data-id="element-2268">
              <strong data-id="element-2269">Monthly:</strong> New introductions.
            </li>
            <li data-id="element-2270">
              <strong data-id="element-2271">Weekly:</strong> Small touchpoints.
            </li>
            <li data-id="element-2272">
              <strong data-id="element-2273">Daily:</strong> One authentic conversation.
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-2274">
            <span className="mr-2" data-id="element-2275">📓</span>
            <span data-id="element-2276">
              Design Your Rhythm: What feels sustainable and energizing for you?
            </span>
          </p>
        </div>
  }];
  return <div className="pt-20" data-id="element-2277">
      <section className="py-16 bg-secondary/5" data-id="element-2278">
        <div className="container mx-auto px-4" data-id="element-2279">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-2280">
            🌐 The Networking Guide: Build Connections That Matter
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-2281">
            This is not a rulebook. It's a playground for you to explore how you
            connect, what feels authentic, and where you want your network to
            take you.
          </p>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto mt-4" data-id="element-2282">
            You'll find reflection prompts, mini-experiments, and action
            challenges — designed so you shape your own networking style.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-2283">
        <div className="container mx-auto px-4" data-id="element-2284">
          <div className="space-y-12" data-id="element-2285">
            {steps.map((step, index) => <Card key={index} className="p-6 border-2 border-gray-200" data-id="element-2286">
                <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-2287">
                  <div className="text-3xl font-bold text-primary" data-id="element-2288">
                    {step.number}
                  </div>
                  <div className="flex-1" data-id="element-2289">
                    <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-2290">
                      {step.title}
                    </h2>
                    <div className="text-secondary" data-id="element-2291">{step.content}</div>
                  </div>
                </div>
              </Card>)}
            <Card className="p-6 border-2 border-gray-200" data-id="element-2292">
              <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-2293">
                ⚡ Quick Experiments (Choose Your Path)
              </h2>
              <div className="space-y-4" data-id="element-2294">
                <p className="flex items-start" data-id="element-2295">
                  <span className="mr-2 text-xl" data-id="element-2296">🎭</span>
                  <span data-id="element-2297">
                    <strong data-id="element-2298">The Actor's Game:</strong> Try introducing yourself
                    3 different ways in one week. Notice what lands.
                  </span>
                </p>
                <p className="flex items-start" data-id="element-2299">
                  <span className="mr-2 text-xl" data-id="element-2300">📩</span>
                  <span data-id="element-2301">
                    <strong data-id="element-2302">The 5-Message Sprint:</strong> Send 5 personalized
                    messages in 5 days. Track replies.
                  </span>
                </p>
                <p className="flex items-start" data-id="element-2303">
                  <span className="mr-2 text-xl" data-id="element-2304">☕</span>
                  <span data-id="element-2305">
                    <strong data-id="element-2306">The Coffee Challenge:</strong> Book 2 chats with
                    people outside your usual circle this month.
                  </span>
                </p>
              </div>
              <p className="mt-6 font-medium" data-id="element-2307">
                👉 By the end of this guide, you don't just "learn how to
                network." You invent your own networking practice — one that
                feels natural, generous, and effective.
              </p>
            </Card>
          </div>
        </div>
      </section>
    </div>;
};